import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import Logo from './Image/miles-morales-logo.png';
import { FaSun, FaMoon } from 'react-icons/fa';

function Navbar() {
  const [darkMode, setDarkMode] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    // Check local storage or document class on mount
    const isDark = document.documentElement.classList.contains('dark') || document.body.classList.contains('dark');
    setDarkMode(isDark);
  }, []);

  const toggleDarkMode = () => {
    const nextDark = !darkMode;
    setDarkMode(nextDark);
    document.documentElement.classList.toggle('dark', nextDark);
    document.body.classList.toggle('dark', nextDark);
  };

  const handleScroll = () => {
    setIsScrolled(window.scrollY > 20);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className="fixed top-0 left-0 w-full z-50 px-4 md:px-10 lg:px-24 pt-4 pb-2 transition-all duration-300 pointer-events-none">
      <nav className={`mx-auto max-w-6xl w-full glass rounded-full px-6 py-3.5 flex justify-between items-center transition-all duration-300 pointer-events-auto ${
        isScrolled 
          ? 'shadow-lg border-opacity-100 translate-y-1' 
          : 'shadow-sm border-opacity-40'
      }`}>
        {/* Logo Section */}
        <NavLink to="/" className="flex items-center gap-3 group">
          <div className="w-8 h-8 rounded-full overflow-hidden border border-teal-500/30 group-hover:border-teal-500 transition-colors duration-300">
            <img src={Logo} alt="avatar" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" />
          </div>
          <span className="font-semibold tracking-wide text-sm md:text-base code-font gradient-text group-hover:opacity-90">
            {"< Amiola_Dev />"}
          </span>
        </NavLink>

        {/* Links & Action Section */}
        <div className="flex items-center gap-8">
          <div className="hidden md:flex items-center gap-6 text-sm font-medium tracking-wide text-slate-600 dark:text-slate-300">
            <NavLink to="/" className={({ isActive }) => `hover:text-teal-600 dark:hover:text-teal-400 transition-colors duration-200 ${isActive ? "text-teal-600 dark:text-teal-400 font-semibold" : ""}`}>
              Home
            </NavLink>
            <NavLink to="/about" className={({ isActive }) => `hover:text-teal-600 dark:hover:text-teal-400 transition-colors duration-200 ${isActive ? "text-teal-600 dark:text-teal-400 font-semibold" : ""}`}>
              About
            </NavLink>
            <NavLink to="/portfolio" className={({ isActive }) => `hover:text-teal-600 dark:hover:text-teal-400 transition-colors duration-200 ${isActive ? "text-teal-600 dark:text-teal-400 font-semibold" : ""}`}>
              Portfolio
            </NavLink>
            <NavLink to="/contact" className={({ isActive }) => `hover:text-teal-600 dark:hover:text-teal-400 transition-colors duration-200 ${isActive ? "text-teal-600 dark:text-teal-400 font-semibold" : ""}`}>
              Contact
            </NavLink>
          </div>

          {/* Theme Toggle Button */}
          <button 
            onClick={toggleDarkMode} 
            className="w-9 h-9 flex items-center justify-center rounded-full border border-slate-200 dark:border-slate-800 bg-white/50 dark:bg-slate-900/50 hover:bg-slate-100 dark:hover:bg-slate-800 transition-all duration-300 cursor-pointer text-slate-600 dark:text-slate-300"
            aria-label="Toggle dark mode"
          >
            {darkMode ? (
              <FaMoon className="w-4 h-4 transition-transform duration-300 hover:rotate-12" />
            ) : (
              <FaSun className="w-4 h-4 transition-transform duration-300 hover:rotate-12" />
            )}
          </button>
        </div>
      </nav>
    </header>
  );
}

export default Navbar;
